<template>
  <!-- <div class='sub-header'>
        <div class='back' @click="$router.go(-1)" v-show="isBack"></div>
        <div class='title'>{{title}}</div>
        <div class="right-btn" v-if="rightText?true:false" @click="submit">{{rightText}}</div>
    </div> -->

  <div class="header-title">
    <div class="back" @click="$router.go(-1)" v-show="isBack"></div>
    <div class="title">
      <h1 :class="isBg ? 'isBg' : ''">{{ title }}</h1>
    </div>
    <div class="right-btn" v-if="rightText ? true : false" @click="submit">
      {{ rightText }}
    </div>
  </div>
</template>



<script>
export default {
  name: "sub-header",
  props: {
    title: {
      type: String,
      default: "",
    },
    isBack: {
      type: Boolean,
      default: true,
    },
    isBg: {
      type: Boolean,
      default: true,
    },
    rightText: {
      type: String,
      default: "",
    },
  },
  methods: {
    submit() {
      this.$emit("submit");
    },
  },
};
</script>

<style lang="scss" scoped>
.header-title {
  width: 100%;
  height: 1.45rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0.45rem;
  box-sizing: border-box;
  position: relative;
  // position: fixed;
  // z-index: 10;
  // left:0;
  // top:0;

  .back {
    width: 0.31rem;
    height: 0.36rem;
    background: url("../../assets/images/common/back.png") no-repeat center;
    background-size: 100%;
    position: relative;
    z-index: 9;
  }
  .title {
    position: absolute;
    left: 0;
    width: 100%;
    top: 50%;
    transform: translateY(-50%);
  }
  h1 {
    position: relative;
    z-index: 9;
    font-size: 0.36rem;
    font-weight: bold;
    color: #333234;
    display: inline-block;
    line-height: 1.2;
    min-width: 3.56rem;
    padding: 0.1rem 0 0.08rem;
    &.isBg {
      &::after,
      &::before {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
      }
      &::before {
        right: 0;
        bottom: 0;
        background: url("../../assets/images/home/goods/tit-bg-1.png") no-repeat
          left top;
        background-size: auto 0.31rem;
      }
      &::after {
        top: 0;
        left: 0;
        background: url("../../assets/images/home/goods/tit-bg-2.png") no-repeat
          right bottom;
        background-size: auto 0.22rem;
      }
    }
  }

  .right-btn {
    font-size: 0.33rem;
    color: #f07d18;
    position: relative;
    z-index: 9;
  }
}
</style>